import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { getStrands } from "../lib/requestFunctions";

export function useStrandData(
    selectedClass: string | undefined,
    selectedSubject: string | undefined,
    enabled: boolean = true,
) {
    const [selectedStrand, setSelectedStrand] = useState<string | undefined>(
        undefined,
    );

    const {
        status: strandStatus,
        fetchStatus: strandFetchStatus,
        data: strands,
    } = useQuery({
        queryKey: ["strands", selectedClass, selectedSubject],
        queryFn: () =>
            getStrands(
                selectedClass ? [parseInt(selectedClass)] : [],
                selectedSubject ? [parseInt(selectedSubject)] : [],
            ),
        enabled: !!selectedClass && !!selectedSubject && enabled,
    });

    useEffect(() => {
        setSelectedStrand(undefined);
    }, [selectedClass, selectedSubject]);

    const strandData = strands?.data?.map((strand) => ({
        key: strand.id,
        text: strand.name,
    })) ?? [];

    return {
        selectedStrand,
        setSelectedStrand,
        strandData,
        strandStatus,
        strandFetchStatus,
        strandLoading: strandStatus === 'pending' && strandFetchStatus === 'fetching',
        strandError: strandStatus === 'error',
    };
}